import { StyledPageHeader, StyledPagesInventoryArchiverUi } from "./styles";
import SearchBar from "./components/SearchBar";
import ResultsContainer from "./components/ResultsContainer";
import { useSearchParams } from "react-router-dom";

export const PagesInventoryArchiverUiDisplay = () => {
  const [searchParams] = useSearchParams();
  const account = searchParams.get("accountId") || "";

  return (
    <StyledPagesInventoryArchiverUi className={"main-container"}>
      <StyledPageHeader>Inventory Archiver</StyledPageHeader>
      <SearchBar />
      <ResultsContainer account={account} />
    </StyledPagesInventoryArchiverUi>
  );
};
